import { AppState } from 'Store'

const getSection = (state: AppState) => state.profile_organization.section
const getOne = (state: AppState) => state.profile_organization.current
const getList = (state: AppState) => state.profile_organization.list
const getEntries = (state: AppState) => state.profile_organization.list.entries
const getDocuments = (state: AppState) => state.profile_organization.documents

export const profileOrganizationSelectors = {
	getSection,
	getOne,
	getList,
	getEntries,
	getDocuments,
}
